import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

export default function MyStoreSettingTopModel(props) {
  const { onClickDownloadMemberList, onClickSubscribe } = props;
  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TopLevelWrapper>
      <LayerWrapper>
        <TextWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text}>{t('myStoreSetting.title')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText}>{t('myStoreSetting.description')}</Text>
        </TextWrapper>
        <RightWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.primary} cursor='pointer' onClick={onClickDownloadMemberList}>{t('myStoreSetting.downloadMemberList')}</Text>
          <SubscribeButton onClick={onClickSubscribe}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('myStoreSetting.subscribeButton')}</Text>
          </SubscribeButton>
        </RightWrapper>
      </LayerWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  // width: 1191px;
  width: 100%;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  // margin-left: 28px;

  gap: 4px;
`;

const RightWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 17px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;

const SubscribeButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 8px 11.5px;

  border-radius: 5px;

  background-color: ${props => props.theme.primary};

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  margin: 0 0 0 0;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.primaryHover};
    }
  }
`;